{"board":"På tavlan","desc":"Beskrivning","from":"Från","no":"Nej","position":"Placera","to":"Mottagare","yes":"Ja"}